module.exports = __webpack_public_path__ + "static/sonae-white-e37cb16b821e35170fc0446bc26a7f53.svg";